import { useIntl } from "react-intl";
import CardFeature from "../../components/card/CardFeature";
import { getFeatureDescription, getFeatureLabel, getFeatureMetaData } from "../../utils/features";
import { FeatureEnum } from "../../types/feature";
import { Helmet } from "react-helmet-async";


const AddFeature = () => {
  const intl = useIntl();

  return (
    <>
      <Helmet>
        <title>
          {intl.formatMessage(
            { id: "features.addDocumentTitle" },
            { appName: import.meta.env.VITE_APP_NAME }
          )}
        </title>        
      </Helmet>
    
      <div className="mb-44 lg:w-fit flex flex-col items-center sm:items-stretch sm:grid sm:grid-cols-2 lg:grid-cols-3  gap-5">
        {
          Object.values(FeatureEnum).map((feat, index) => (
            <CardFeature key={index}
              title={getFeatureLabel(intl, feat)!}
              description={getFeatureDescription(intl, feat)}
              icon={getFeatureMetaData(feat)?.icon}
              decor={getFeatureMetaData(feat)?.decor}
              link={feat}
            />
          ))
        }
        <CardFeature
          link="#"
          title={intl.formatMessage({ id: "features.comingSoon" })}
          withDecor={false}
        />
      </div>
    </>
  )
}

export default AddFeature;
